import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

const name = (d) => [d.first_name, d.last_name].filter(Boolean).join(" ") || d.email || "—";

/** Debounced driver search + list. `load(q)` returns { data }. `actions(d)` renders per-row buttons. */
export function DriverList({ load, reloadKey, onSelect, actions, empty, testid }) {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const t = setTimeout(async () => {
      const { data, error } = await load(q);
      if (cancelled) return;
      setErr(error?.message || null);
      setRows(data || []);
    }, 250);
    return () => { cancelled = true; clearTimeout(t); };
  }, [q, load, reloadKey]);

  return (
    <div className="space-y-3" data-testid={testid}>
      <div className="relative max-w-md">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-slate-400" />
        <Input className="pl-8" placeholder="Search name, email or mobile" value={q}
               onChange={(e) => setQ(e.target.value)} data-testid={`${testid}-search`} />
      </div>
      <div className="rounded-md border bg-white divide-y">
        {rows === null && <div className="p-4 text-sm text-slate-500">Loading…</div>}
        {err && <div className="p-4 text-sm text-rose-600" data-testid={`${testid}-error`}>Couldn&apos;t load drivers: {err}</div>}
        {!err && rows?.length === 0 && <div className="p-4 text-sm text-slate-500" data-testid={`${testid}-empty`}>{empty}</div>}
        {rows?.map((d) => (
          <div key={d.id} className={`flex items-center justify-between gap-3 px-4 py-3 ${onSelect ? "cursor-pointer hover:bg-slate-50" : ""}`}
               onClick={() => onSelect?.(d)} data-testid={`${testid}-row-${d.id}`}>
            <div className="min-w-0">
              <div className="font-medium text-sm truncate">{name(d)}</div>
              <div className="text-xs text-slate-500 truncate">{[d.email, d.phone].filter(Boolean).join(" · ")}</div>
            </div>
            {actions && <div onClick={(e) => e.stopPropagation()}>{actions(d)}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}

export const driverName = name;
